export default "__VITE_ASSET___WeT3AzG__"